module.exports = "/_next/static/images/OgHealthcare-661dd853b2e4d0981c8b6046c92c64bd.png";